export const config = {
  title: "Money Head LLC | Ohio",
  meta: {
    description:
      "Money Head LLC provides quality products and services in Ohio. We offer competitive wholesale pricing and are open 24/7 for your convenience.",
    keywords: [
      "Money Head LLC",
      "Ohio Business",
      "Wholesale Products",
      "24/7 Service",
      "Quality Products",
      "Competitive Pricing",
      "Ohio Wholesale"
    ],
    author: "Money Head LLC",
    canonicalUrl: "https://www.moneyheadllc.com/",
  },
  sections: {
    header: {
      businessName: "Money Head LLC",
    },
    sectionB: {
      heroTitle: "Your Trusted Business Partner in Ohio",
      heroSubtitle: "Quality Products & Services Available 24/7",
      learnAboutText: "Contact Us Today",
      phoneNumber: "2347161120",
      phoneLabel: "(234) 716-1120",
      heroBackgroundImage:
        "https://primary.jwwb.nl/public/q/z/f/temp-ltfxnvbxrsmeakbwaisz/24-karat-comm-in-6-25-high.jpg?enable-io=true&enable=upscale&crop=1920%2C1920%2Cx0%2Cy320%2Csafe&width=1066&height=1066",
      cardData: [
        {
          title: "Quality Products",
          description:
            "We provide high-quality products that meet your needs and exceed your expectations.",
        },
        {
          title: "Wholesale Pricing",
          description:
            "Competitive wholesale pricing with the best deals in Ohio for bulk orders and business customers.",
        },
        {
          title: "24/7 Availability",
          description:
            "We're always open and available to serve you around the clock, whenever you need us.",
        },
      ],
      description:
        "Money Head LLC is your reliable business partner in Ohio, offering quality products and services with competitive pricing. We're committed to serving our customers 24/7.",
    },
    sectionC: {
      servicesTitle: "Our Business Services",
      servicesDescription:
        "We provide comprehensive business solutions with competitive pricing and reliable service throughout Ohio.",
      cards: [
        {
          title: "Wholesale Solutions",
          description:
            "Comprehensive wholesale solutions designed to meet the needs of businesses across Ohio.",
          imageSrc: "https://primary.jwwb.nl/public/q/z/f/temp-ltfxnvbxrsmeakbwaisz/thin-mintz-ex-smalls-4-25-high.jpg?enable-io=true&enable=upscale&crop=1920%2C1920%2Cx0%2Cy320%2Csafe&width=1066&height=1066",
          imageAlt: "Wholesale Solutions",
        },
        {
          title: "Product Supply",
          description:
            "Reliable product supply chain with consistent quality and competitive wholesale pricing for businesses.",
          imageSrc: "https://primary.jwwb.nl/public/q/z/f/temp-ltfxnvbxrsmeakbwaisz/purple-pancake-in-bigs-4-25-high-558dnv.jpg?enable-io=true&enable=upscale&crop=1920%2C2557%2Cx0%2Cy2%2Csafe&width=362&height=482",
          imageAlt: "Product Supply Services",
        },
        {
          title: "Customer Support",
          description:
            "Round-the-clock customer support to ensure your business needs are met at any time of day.",
          imageSrc: "https://primary.jwwb.nl/public/q/z/f/temp-ltfxnvbxrsmeakbwaisz/tropical-summer-ldb-5-25-high.jpg?enable-io=true&enable=upscale&crop=1920%2C1920%2Cx0%2Cy320%2Csafe&width=362&height=362",
          imageAlt: "Customer Support Services",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Business Consultation",
        "Custom Orders",
        "Bulk Purchasing",
        "Delivery Services",
        "Account Management",
      ],
    },
    sectionD: {
      aboutTitle: "About Money Head LLC",
      aboutImage: {
        src: "https://primary.jwwb.nl/public/q/z/f/temp-ltfxnvbxrsmeakbwaisz/bangkok-purple-com-in-8-25-high.jpg?enable-io=true&enable=upscale&crop=1920%2C2230%2Cx0%2Cy165%2Csafe&width=521&height=605",
        alt: "Money Head LLC Team",
      },
      aboutText: [
        "Money Head LLC is a trusted business partner serving clients throughout Ohio. We specialize in providing quality products and services with competitive wholesale pricing that helps businesses succeed.",
        "Our commitment to 24/7 availability ensures that we're always here when you need us. Whether you're looking for bulk orders, wholesale pricing, or reliable business solutions, Money Head LLC delivers the quality and service you can depend on.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Money Head LLC",
      businessName: "Money Head LLC",
      contact: {
        phone: "2347161120",
        phoneLabel: "(234) 716-1120",
        email: "shawnsteele0425@gmail.com",
        website: "https://www.moneyheadllc.com/",
        address: "Ohio",
      },
      socialMedia: {
      },
    },
    sectionF: {
      address: "Ohio",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3048000.123456789!2d-82.9071778!3d40.4172390!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8836e7f5f1234567%3A0x1234567890abcdef!2sOhio%2C%20USA!5e0!3m2!1sen!2sus!4v1698765432100!5m2!1sen!2sus",
    },
  },
};

export default config;